module.exports = __webpack_public_path__ + "static/media/sites_outline.53f96524.svg";